var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-admin-workflow" }, [
    _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/email-template" } }, [
              _vm._v(_vm._s(_vm.trans("template.template"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("template.edit_template")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("template.edit_template"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "linear-page-copy" }, [
          _vm._v(
            _vm._s(_vm.trans("template.available_fields")) +
              ": " +
              _vm._s(_vm.fields)
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-saas linear-admin-panel" }, [
      _c(
        "form",
        {
          staticClass: "linear-admin-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
            keydown: function ($event) {
              return _vm.templateForm.errors.clear($event.target.name)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v(_vm._s(_vm.trans("template.subject"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.templateForm.subject,
                    expression: "templateForm.subject",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  value: "",
                  name: "subject",
                  placeholder: _vm.trans("template.subject"),
                },
                domProps: { value: _vm.templateForm.subject },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.templateForm, "subject", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.templateForm,
                  "prop-name": "subject",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("html-editor", {
                attrs: {
                  name: "body",
                  model: _vm.templateForm.body,
                  isUpdate: "true",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.templateForm, "body", $event)
                  },
                  clearErrors: function ($event) {
                    return _vm.templateForm.errors.clear("body")
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: { "form-name": _vm.templateForm, "prop-name": "body" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap gap-2 justify-content-end mt-3" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-sm admin-form-btn-cancel",
                  attrs: { to: "/email-template" },
                },
                [_vm._v(_vm._s(_vm.trans("general.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                  attrs: { type: "submit" },
                },
                [_vm._v(_vm._s(_vm.trans("general.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }